import type { Testimonial } from '../types/content'

export const testimonials: Testimonial[] = [
  {
    name: 'Marcus Bell',
    initials: 'MB',
    location: { en: 'Lake Highlands, Dallas', es: 'Lake Highlands, Dallas' },
    service: { en: 'Interior painting', es: 'Pintura interior' },
    quote: {
      en: 'They painted our entire first floor in four days and you cannot find a single line out of place. Floors were covered every morning and swept every evening. Rare to see that kind of care.',
      es: 'Pintaron todo el primer piso en cuatro días y no encuentras una sola línea mal hecha. Cubrían los pisos cada mañana y barrían cada tarde. Muy raro ver ese cuidado.',
    },
  },
  {
    name: 'Liliana Ortega',
    initials: 'LO',
    location: { en: 'Oak Cliff, Dallas', es: 'Oak Cliff, Dallas' },
    service: { en: 'Kitchen remodel', es: 'Remodelación de cocina' },
    quote: {
      en: 'Nos explicaron todo en español y nos mandaron fotos cada día. La cocina quedó como nueva y respetaron el presupuesto exacto que nos dieron al principio.',
      es: 'Nos explicaron todo en español y nos mandaron fotos cada día. La cocina quedó como nueva y respetaron el presupuesto exacto que nos dieron al principio.',
    },
  },
  {
    name: 'Derek Nguyen',
    initials: 'DN',
    location: { en: 'Plano, TX', es: 'Plano, TX' },
    service: { en: 'LVP flooring', es: 'Piso LVP' },
    quote: {
      en: 'They leveled a subfloor two other contractors told me was fine. Zero squeaks, perfect transitions at every doorway. Worth every dollar.',
      es: 'Nivelaron un subpiso que otros dos contratistas me dijeron que estaba bien. Cero crujidos y transiciones perfectas en cada puerta. Valió cada dólar.',
    },
  },
  {
    name: 'Sandra Pierce',
    initials: 'SP',
    location: { en: 'Arlington, TX', es: 'Arlington, TX' },
    service: { en: 'Drywall repair', es: 'Reparación de drywall' },
    quote: {
      en: 'A pipe burst and I had a hole in my living room wall. They came out the next morning, matched the texture exactly, and I genuinely cannot tell where it was.',
      es: 'Se rompió una tubería y tenía un hoyo en la pared de la sala. Vinieron a la mañana siguiente, igualaron la textura exacta y de verdad no se nota dónde estaba.',
    },
  },
  {
    name: 'Rogelio Márquez',
    initials: 'RM',
    location: { en: 'Fort Worth, TX', es: 'Fort Worth, TX' },
    service: { en: 'Exterior painting', es: 'Pintura exterior' },
    quote: {
      en: 'Two summers later the exterior still looks like the week they finished. They fixed rotted trim I did not even know about before painting.',
      es: 'Dos veranos después el exterior sigue como la semana que terminaron. Repararon madera podrida que yo no sabía que tenía antes de pintar.',
    },
  },
  {
    name: 'Amanda Whitfield',
    initials: 'AW',
    location: { en: 'Irving, TX', es: 'Irving, TX' },
    service: { en: 'Demolition & junk removal', es: 'Demolición y retiro de basura' },
    quote: {
      en: 'Cleared out an entire rental property in one day, dumpster included. Family-run, straightforward pricing, and they answered the phone every time I called.',
      es: 'Vaciaron una propiedad completa en un día, con dumpster incluido. Negocio familiar, precios claros, y contestaron el teléfono cada vez que llamé.',
    },
  },
]
